class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.relatedProducts = this.relatedProducts.bind(this);
    this.hasInitialized = false;
  }

  connectedCallback() {
    if (this.hasInitialized) return;

    this.hasInitialized = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.relatedProducts, { once: true });
      return;
    }

    this.relatedProducts();
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.relatedProducts);
  }

  relatedProducts() {
    const forceHide = (element) => {
      if (!element) return;
      element.hidden = true;
      element.style.setProperty('display', 'none', 'important');
    };

    if (document.querySelector('.carryology-oos-banner.generalized-oos-banner')) {
      forceHide(this);
      forceHide(this.closest('.shopify-section'));
      return;
    }

    const relatedProductsSection = this;
    const url = relatedProductsSection.dataset.url;
    if (!url) return;

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(relatedProductsSection);

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.related-products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            relatedProductsSection.innerHTML = recommendations.innerHTML;

            if (typeof productCardColorUpdateFunction === 'function') {
              productCardColorUpdateFunction();
            }

            window.productCardColorSwatchesScroll?.(relatedProductsSection);
            window.initProductCardVideos?.(relatedProductsSection);
            this.createSlider();
          }
        })
        .catch(e => {
          console.error(e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      threshold: 0,
      rootMargin: '1000px'
    });

    observer.observe(relatedProductsSection);
  }

  createSlider() {
    var drag = false;

    this.querySelectorAll('.related-products__recommendations').forEach(slider => {
      if (slider.dataset.sliderInitialized === 'true') return;
      slider.dataset.sliderInitialized = 'true';

      new KeenSlider(slider, {
        dragChecked() {
          drag = true;
        },
        dragEnded() {
          setTimeout(() => (drag = false), 0);
        },
        created() {
          window.productCardColorSwatchesScroll?.(slider.closest('.related-products') || document);

          slider.addEventListener("click", (e) => {
            if (drag) {
              e.stopPropagation();
              e.preventDefault();
            }
          });
        },
        breakpoints: {
          '(max-width: 449px)': {
            slides: {
              perView: 1.35,
              spacing: 4
            }
          },
          '(min-width: 450px)': {
            slides: {
              perView: 2.5,
              spacing: 4
            }
          },
          '(min-width: 990px)': {
            disabled: true,
          },
        },
      }, [navigation]);
    });
  }
}

customElements.define('related-products', RelatedProducts);
